import { FC } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RoleGateway } from 'src/components/role-gateway';
import { ReportingUploadsDraftedDetail } from 'src/pages/reporting/products/drafted/detail';
import { ReportingUploadsDraftedOverview } from 'src/pages/reporting/products/drafted/overview';
import { ReportingUploadsUploadedDetail } from 'src/pages/reporting/products/uploaded/detail';
import { ReportingUploadsUploadedOverview } from 'src/pages/reporting/products/uploaded/overview';
import { CapacityManagement } from 'src/pages/transport/network-points/details/availability-and-price-data/overview/capacity-management';

export const ReportingUploads: FC = () => {
  const { search } = useLocation();
  return (
    <CapacityManagement>
      {(root) => (
        <Switch>
          <Route path="/reporting/products/uploaded" exact>
            {/*
              RoleGateway is needed, because "/rest/uploads/report"
              doesn't handle 401 and 403, but returns 500
            */}
            <RoleGateway allowed={['TSO_USER']}>
              <ReportingUploadsUploadedOverview capacityManagementRoot={root} />
            </RoleGateway>
          </Route>

          <Route path="/reporting/products" exact>
            <Redirect
              to={{ pathname: '/reporting/products/uploaded', search }}
            />
          </Route>

          <Route path="/reporting/products/uploaded/:rawDataId" exact>
            <ReportingUploadsUploadedDetail capacityManagementRoot={root} />
          </Route>

          {root && (
            <Route path="/reporting/products/drafted" exact>
              <ReportingUploadsDraftedOverview capacityManagementRoot={root} />
            </Route>
          )}

          {root && (
            <Route path="/reporting/products/drafted/:draftedProductId" exact>
              <ReportingUploadsDraftedDetail capacityManagementRoot={root} />
            </Route>
          )}

          <Route>
            <ThrowNotFound />
          </Route>
        </Switch>
      )}
    </CapacityManagement>
  );
};
